/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Node } from "@tiptap/core";
import LiveCodeBlockNodeView from "./components/LiveCodeBlockNodeView";
import { DEFAULT_ATTRIBUTES, EXTENSION_NAME } from "./constants";

export const LiveCodeBlock = /* @__PURE__ */ Node.create({
  name: EXTENSION_NAME,
  content: "",
  marks: "",
  group: "block",
  selectable: true,
  atom: true,
  draggable: true,

  addOptions() {
    return {
      ...this.parent?.(),
      HTMLAttributes: {
        class: "block-live-code",
      },
    };
  },

  addAttributes() {
    return {
      caption: {
        default: DEFAULT_ATTRIBUTES.caption,
      },
      codeStack: {
        default: DEFAULT_ATTRIBUTES.codeStack,
      },
      data: {
        default: DEFAULT_ATTRIBUTES.data,
      },
    };
  },
});

export const LiveCodeBlockNodeMapping = {
  [EXTENSION_NAME]: LiveCodeBlockNodeView,
};
